export const types = {
    CONNECT: 'CONNECT',
    ADDMAILBOXACCOUNT:'ADD-MAILBOX-ACCOUNT',
    REMOVEFROMUSERMAILGROUP:'REMOVE-USER-FROM-MAIL-GROUP',
    DISABLEMAILBOX: 'DISABLE-MAILBOX',
    DELETEMAILBOX:'DELETE-MAILBOX',
    CHANGEMAILBOXSIZE:'CHANGE-MAILBOX-SIZE',
    ADDUSERTOMAILGROUP:'ADD-USER-TO-MAIL-GROUP'


};